(function () {
  const root = document.querySelector('[data-mb-root]');
  if (!root) return;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.from(root.querySelectorAll(s));
  const tiers = $$('[data-mb-tier]');
  const rite = $('[data-mb-rite]');
  const purchaseButtons = $$('[data-mb-atc], [data-mb-atc-sticky]');
  const situationInput = $('[data-mb-situation]');
  const intentionInput = $('[data-mb-intention]');
  let checkoutAttempt = null;
  let selected = Number(root.dataset.defaultTier || 2);
  let busy = false;
  let refreshing = null;
  let lastRefresh = 0;

  function selectedEl() { return tiers.find((el) => Number(el.dataset.mbTier) === selected) || tiers[0]; }
  function state(el) { return el?.dataset.stockState || 'coming-soon'; }
  function allSoldOut() { return tiers.length > 0 && tiers.every((el) => state(el) === 'sold-out'); }
  function riteOn() { return rite && rite.getAttribute('aria-pressed') === 'true'; }
  function errorMessage(message) {
    const error = $('[data-mb-error]');
    if (error) {
      error.textContent = message; error.hidden = !message;
      if (message) window.requestAnimationFrame(() => error.scrollIntoView({ block: 'center', behavior: 'instant' }));
    }
    if ($('[data-mb-recovery]')) $('[data-mb-recovery]').hidden = true;
  }

  function render() {
    tiers.forEach((el) => {
      el.setAttribute('aria-checked', Number(el.dataset.mbTier) === selected ? 'true' : 'false');
      el.disabled = busy;
      const badge = el.querySelector('[data-mb-tier-badge]');
      if (badge) {
        badge.hidden = state(el) === 'available' && Number(el.dataset.mbTier) !== 2;
        badge.textContent = state(el) === 'sold-out' ? 'Sold out' : state(el) === 'coming-soon' ? 'Coming soon' : 'Most chosen';
      }
    });
    if (rite) {
      rite.dataset.stockState = root.dataset.riteState || 'coming-soon';
      rite.disabled = busy || state(rite) !== 'available';
      if (state(rite) !== 'available') rite.setAttribute('aria-pressed', 'false');
      const badge = $('[data-mb-rite-badge]');
      if (badge) { badge.hidden = state(rite) === 'available'; badge.textContent = state(rite) === 'sold-out' ? 'Sold out' : 'Coming soon'; }
    }
    $$('[data-mb-includes]').forEach((el) => { el.hidden = Number(el.dataset.mbIncludes) !== selected; });
    const stock = state(selectedEl());
    const available = stock === 'available' && Boolean(selectedEl()?.dataset.variantId);
    const label = busy ? 'Opening checkout…' : stock === 'sold-out' ? 'Sold out' : !available ? 'Coming soon' : 'Checkout';
    if (situationInput) situationInput.disabled = busy;
    if (intentionInput) intentionInput.disabled = busy || !riteOn();
    if ($('[data-mb-intention-wrap]')) $('[data-mb-intention-wrap]').hidden = !riteOn();
    if (rite) rite.setAttribute('aria-expanded', String(riteOn()));
    $$('[data-mb-atc-label], [data-mb-atc-label-sticky]').forEach((el) => { el.textContent = label; });
    purchaseButtons.forEach((el) => {
      el.disabled = busy || !available;
      el.dataset.stockState = stock;
      el.setAttribute('aria-busy', String(busy));
    });
    const formatted = riteOn() && selectedEl()?.dataset.priceWithRiteFormatted
      ? selectedEl().dataset.priceWithRiteFormatted : selectedEl()?.dataset.priceFormatted;
    const amount = available && !busy && formatted ? ' · ' + formatted : '';
    $$('[data-mb-total], [data-mb-total-sticky]').forEach((el) => { el.textContent = amount; });
    const selection = $('[data-mb-sticky-selection]');
    if (selection) selection.textContent = (selectedEl()?.querySelector('.mb-tier__top strong')?.textContent || '').replace(/^Mabon:\s*/, '') + (riteOn() ? ' + Apple Rite' : '');
    const notice = $('[data-mb-availability]');
    if (notice) {
      const alternative = tiers.some((el) => state(el) === 'available');
      notice.hidden = available;
      notice.textContent = allSoldOut() ? 'All Mabon readings have sold out.'
        : stock === 'sold-out' ? 'This reading has sold out.' + (alternative ? ' You can choose another available reading above.' : '')
        : 'This reading is not available yet.' + (alternative ? ' You can choose another available reading above.' : '');
    }
    const next = $('[data-mb-next]');
    if (next) next.hidden = !available;
    if (allSoldOut() && $('[data-mb-reading-countdown-wrap]')) $('[data-mb-reading-countdown-wrap]').hidden = true;
  }
  tiers.forEach((el) => el.addEventListener('click', () => {
    if (busy) return;
    selected = Number(el.dataset.mbTier); errorMessage(''); render();
  }));
  if (rite) rite.addEventListener('click', () => {
    if (busy || state(rite) !== 'available') return;
    rite.setAttribute('aria-pressed', riteOn() ? 'false' : 'true'); errorMessage(''); render();
  });

  const info = $('[data-mb-rite-info]');
  const tooltip = $('[data-mb-rite-tooltip]');
  function showRiteInfo(open) {
    if (!info || !tooltip) return;
    info.setAttribute('aria-expanded', String(open)); tooltip.hidden = !open;
  }
  if (info && tooltip) {
    info.addEventListener('click', () => showRiteInfo(tooltip.hidden));
    document.addEventListener('click', (event) => {
      if (!info.contains(event.target) && !tooltip.contains(event.target)) showRiteInfo(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !tooltip.hidden) { showRiteInfo(false); info.focus(); }
    });
  }

  // Re-render just this section on return to an open tab, or after a stock rejection.
  // This keeps Shopify's variant availability and localized prices authoritative.
  function refreshAvailability() {
    if (refreshing) return refreshing;
    if (!root.dataset.sectionId) return Promise.resolve(false);
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', root.dataset.sectionId);
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 8000);
    refreshing = (async () => {
      try {
        const response = await fetch(url.toString(), { cache: 'no-store', signal: controller.signal });
        if (!response.ok) return false;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-mb-root]');
        if (!fresh || fresh.dataset.sectionId !== root.dataset.sectionId) return false;
        for (const el of tiers) {
          const current = fresh.querySelector('[data-mb-tier="' + el.dataset.mbTier + '"]');
          if (!current) return false;
        }
        tiers.forEach((el) => {
          const current = fresh.querySelector('[data-mb-tier="' + el.dataset.mbTier + '"]');
          for (const key of ['variantId', 'stockState', 'priceCents', 'priceFormatted', 'priceWithRiteFormatted']) {
            if (current.dataset[key] !== undefined) el.dataset[key] = current.dataset[key];
            else delete el.dataset[key];
          }
          for (const selector of ['.mb-tier__price', '.mb-tier__top strong']) {
            const from = current.querySelector(selector), to = el.querySelector(selector);
            if (from && to) to.textContent = from.textContent;
          }
        });
        for (const key of ['riteState', 'riteVariant', 'riteCents']) {
          if (fresh.dataset[key] !== undefined) root.dataset[key] = fresh.dataset[key];
          else delete root.dataset[key];
        }
        const price = fresh.querySelector('.mb-rite__price');
        if (price && $('.mb-rite__price')) $('.mb-rite__price').textContent = price.textContent;
        lastRefresh = Date.now(); render(); return true;
      } catch (_) { return false; }
      finally { window.clearTimeout(timeout); refreshing = null; }
    })();
    return refreshing;
  }
  function refreshOnReturn() {
    if (!document.hidden && !busy && Date.now() - lastRefresh > 30000) refreshAvailability();
  }
  document.addEventListener('visibilitychange', refreshOnReturn);
  window.addEventListener('focus', refreshOnReturn);
  window.addEventListener('pageshow', (event) => { if (event.persisted) { busy = false; render(); refreshAvailability(); } });

  async function cartRequest(url, options = {}) {
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 15000);
    try { return await fetch(url, { ...options, signal: controller.signal }); }
    finally { window.clearTimeout(timeout); }
  }

  async function add() {
    if (busy) return;
    if (refreshing) await refreshing;
    if (busy || state(selectedEl()) !== 'available' || !selectedEl()?.dataset.variantId) { render(); return; }
    if (riteOn() && (state(rite) !== 'available' || !root.dataset.riteVariant)) { render(); return; }
    const includedRite = riteOn();
    const situation = situationInput?.value.trim() || '';
    const intention = includedRite ? intentionInput?.value.trim() || '' : '';
    const items = [{ id: Number(selectedEl().dataset.variantId), quantity: 1, properties: {
      'What situation have you been weighing?': situation || 'Open reading'
    } }];
    if (includedRite) items.push({ id: Number(root.dataset.riteVariant), quantity: 1, properties: {
      'What would you like to put more weight behind?': intention || 'Open intention'
    } });
    const signature = JSON.stringify(items);
    busy = true; errorMessage(''); render();
    try {
      // Read first to preserve an existing basket and recover an accepted request
      // whose response was lost, without adding the same selection a second time.
      const cartResponse = await cartRequest((root.dataset.cartUrl || '/cart') + '.js', { cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Cart could not be read');
      const cart = await cartResponse.json();
      const previous = checkoutAttempt && cart.items.filter((item) => item.properties?._mabon_checkout === checkoutAttempt.id);
      if (previous?.length) {
        const complete = checkoutAttempt.signature === signature && previous.length === items.length
          && items.every((item) => previous.some((saved) => Number(saved.variant_id) === item.id && saved.quantity === 1));
        if (complete) { window.location.assign(root.dataset.checkoutUrl || '/checkout'); return; }
        errorMessage('Your previous selection is already saved. Please review it before continuing.');
        if ($('[data-mb-recovery]')) $('[data-mb-recovery]').hidden = false;
        busy = false; render(); return;
      }
      checkoutAttempt = {
        id: checkoutAttempt?.signature === signature ? checkoutAttempt.id
          : window.crypto?.randomUUID?.() || 'mabon-' + Date.now() + '-' + Math.random().toString(36).slice(2),
        signature
      };
      items.forEach((item) => { item.properties._mabon_checkout = checkoutAttempt.id; });
      const answerNote = situation ? 'What situation have you been weighing?\n' + situation : '[Open reading. No specific questions.]';
      const riteNote = includedRite && intention ? 'Harvest Moon Apple Rite — What would you like to put more weight behind?\n' + intention : '';
      const existingNote = cart.item_count > 0 ? (cart.note || '').trim() : '';
      const note = [...new Set([existingNote, answerNote, riteNote].filter(Boolean))].join('\n\n');
      const attributes = { mabon_situation: situation, reading_mode: situation || existingNote ? 'specific' : 'open' };
      if (includedRite) attributes.mabon_rite_intention = intention;
      const response = await cartRequest((root.dataset.cartAddUrl || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items, note, attributes })
      });
      if (response.status === 422) {
        const body = await response.json().catch(() => ({}));
        await refreshAvailability();
        if (state(selectedEl()) === 'sold-out') errorMessage(allSoldOut() ? 'These Mabon readings have now sold out.' : 'This reading has just sold out. Please choose another available reading.');
        else if (includedRite && state(rite) === 'sold-out') errorMessage('The Harvest Moon Apple Rite has just sold out and has been deselected. You can continue with your reading.');
        else errorMessage(typeof body.description === 'string' ? body.description : 'This selection is no longer available. Please refresh the page and try again.');
      } else {
        if (!response.ok) throw new Error('Cart request failed');
        window.location.assign(root.dataset.checkoutUrl || '/checkout');
        return;
      }
    } catch (_) { errorMessage('Checkout could not be opened. Your answers are still here. Please try again.'); }
    busy = false; render();
  }
  purchaseButtons.forEach((el) => el.addEventListener('click', add));

  function countdown(iso, wrap, out, expiredText) {
    const deadline = Date.parse(iso || '');
    if (!out || Number.isNaN(deadline)) return;
    function tick() {
      const left = deadline - Date.now();
      if (left <= 0) { if (wrap) wrap.hidden = true; out.textContent = expiredText || ''; return; }
      const days = Math.floor(left / 86400000), hours = Math.floor((left % 86400000) / 3600000);
      const mins = Math.floor((left % 3600000) / 60000), secs = Math.floor((left % 60000) / 1000);
      out.textContent = `${days ? days + 'd ' : ''}${hours}h ${mins}m ${secs}s`;
      if (wrap) wrap.hidden = allSoldOut();
      window.setTimeout(tick, 1000);
    }
    tick();
  }
  countdown(root.dataset.readingDeadline, $('[data-mb-reading-countdown-wrap]'), $('[data-mb-reading-countdown]'));
  countdown(root.dataset.riteDeadline, null, $('[data-mb-rite-countdown]'), 'Closed');
  const sticky = $('[data-mb-sticky]'), inlineButton = $('[data-mb-atc]');
  if (sticky && inlineButton) {
    const mobile = window.matchMedia('(max-width: 760px)');
    let queued = false;
    function updateSticky() {
      queued = false;
      const rect = inlineButton.getBoundingClientRect();
      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      const bottom = top + (viewport?.height || window.innerHeight);
      const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
      // Reserve the bar's height when deciding if the inline action is reachable.
      const inlineVisible = rect.top >= top + 90 && rect.bottom <= bottom - 104;
      sticky.hidden = !mobile.matches || editing || inlineVisible;
    }
    function scheduleSticky() {
      if (!queued) { queued = true; window.requestAnimationFrame(updateSticky); }
    }
    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky);
    document.addEventListener('focusin', scheduleSticky);
    document.addEventListener('focusout', scheduleSticky);
    window.visualViewport?.addEventListener('resize', scheduleSticky);
    window.visualViewport?.addEventListener('scroll', scheduleSticky);
    if ('ResizeObserver' in window) new ResizeObserver(scheduleSticky).observe(root);
    updateSticky();
  }
  render();
})();
